import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { getPersons } from 'core/people/api/peopleService'
import { userLoggedOut } from 'core/session/slices/session'
import { PeopleState, ApiPersonsResponse } from './types'

const initialState: PeopleState = {
  persons: {},
}

const peopleSlice = createSlice({
  name: 'people',
  initialState,
  reducers: {
    personsLoaded(state, action: PayloadAction<ApiMiddlewarePayload<ApiPersonsResponse>>) {
      state.persons = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { personsLoaded } = peopleSlice.actions
export default peopleSlice.reducer

export const loadPersonsData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      list: () => getPersons(),
    },
    payloadAction: personsLoaded,
  })
}
